(function () {
    'use strict';

    angular
        .module('app')
        .controller('DocumentMergeCtrl', DocumentMergeCtrl);

    DocumentMergeCtrl.$inject = ['$q', 'entityId', 'entityTemplateId', 'entityTemplateName', 'EntityTemplatesService', 'SystemService', 'TagsService', 'DialogInstance', 'DocumentTemplate'];

    function DocumentMergeCtrl($q, entityId, entityTemplateId, entityTemplateName, EntityTemplatesService, SystemService, TagsService, DialogInstance, DocumentTemplate) {
        /* jshint validthis:true */
        var vm = this;
        vm.mergeDetails = {};
        vm.entityTemplateId = angular.copy(entityTemplateId);
        vm.entityTemplateName = angular.copy(entityTemplateName);
        vm.documentTemplates = [];
        vm.ok = ok;
        vm.cancel = cancel;
        vm.documentTemplatePreview = documentTemplatePreview;
        vm.updateMergeDetails = updateMergeDetails;
        vm.tagsControl = {};

        Object.defineProperty(vm, 'saveToFieldInvalid', {
            get: function () {
                return !_.isNil(vm.mergeDetails) && !vm.mergeDetails.SaveToCurrentEntity && !vm.mergeDetails.SaveToOrganisation && !vm.mergeDetails.SaveToCurrentUser &&
                    !(!_.isNil(vm.mergeDetails.SaveToEntities) && vm.mergeDetails.SaveToEntities.length > 0);
            }
        });

        activate();

        function activate() {
            var loadPromises = [];
            loadPromises.push(loadDocumentTemplates());
            loadPromises.push(loadFileConversionFormats());
            loadPromises.push(loadTags());

            $q.all(loadPromises)
                .then(function () {
                });
        }

        function loadDocumentTemplates() {
            return EntityTemplatesService.getDocumentTemplates(vm.entityTemplateId, DocumentTemplate.UsageTypes.Document.Reference, entityId)
                .then(getDocumentTemplatesOk)
                .catch(getDocumentTemplatesError);

            function getDocumentTemplatesOk(data) {
                vm.documentTemplates = data;
            }

            function getDocumentTemplatesError(response) {

            }
        }

        function loadFileConversionFormats() {
            return SystemService.getFileConversionFormats()
                .then(getFileConversionFormatsOk)
                .catch(getFileConversionFormatError);

            function getFileConversionFormatsOk(data) {
                vm.fileConversionFormats = data;
            }

            function getFileConversionFormatError(response) {

            }
        }

        function loadTags() {
            return TagsService.query({ tagUsage: 'File' })
                .then(getTagsOk, getTagsError);

            function getTagsOk(data) {
                vm.tags = data.Tags;
            }

            function getTagsError(response) {
                DialogService.error('Error fetching Tags', response);
            }
        }

        function updateMergeDetails() {
            var selectedTemplate = _.find(vm.documentTemplates, function (documentTemplate) {
                return vm.mergeDetails.DocumentTemplateId === documentTemplate.Id;
            });

            // Make the extension lower case to ensure correct functionality.
            var documentTemplateExtension = '';
            if (!_.isNil(selectedTemplate) && !_.isNil(selectedTemplate.Extension)) {
                documentTemplateExtension = selectedTemplate.Extension.toLowerCase();
            }

            if (angular.isDefined(vm.fileConversionFormats) && angular.isDefined(vm.fileConversionFormats[documentTemplateExtension])) {
                vm.availableFormats = vm.fileConversionFormats[documentTemplateExtension];
            } else {
                vm.availableFormats = [];
            }

            if (!angular.isUndefined(selectedTemplate) && selectedTemplate !== null) {
                vm.mergeDetails.FileDescription = selectedTemplate.FileDescription;
                vm.mergeDetails.FileName = selectedTemplate.FileName;
                vm.mergeDetails.OutputFormat = selectedTemplate.OutputFormat;
                vm.mergeDetails.Tags = angular.copy(selectedTemplate.Tags);
                vm.mergeDetails.SaveToCurrentEntity = selectedTemplate.SaveToCurrentEntity;
                vm.mergeDetails.SaveToCurrentUser = selectedTemplate.SaveToCurrentUser;
                vm.mergeDetails.SaveToOrganisation = selectedTemplate.SaveToOrganisation;
                vm.mergeDetails.SaveToEntities = angular.copy(selectedTemplate.SaveToEntities);
                vm.tagsControl.refresh();
            }
        }

        function ok() {
            DialogInstance.ok(vm.mergeDetails);
        }

        function cancel() {
            DialogInstance.cancel();
        }

        function documentTemplatePreview(documentTemplate) {
            return documentTemplate.Name;
        }
    }
})();
